import type { FactTrajectoryPointEntity } from '../service/entities';

function compareTrajectoryPointsByMd(left: FactTrajectoryPointEntity, right: FactTrajectoryPointEntity): number {
  const leftMd = left.data.md;
  const rightMd = right.data.md;
  const leftValid = typeof leftMd === 'number' && !Number.isNaN(leftMd);
  const rightValid = typeof rightMd === 'number' && !Number.isNaN(rightMd);

  if (!leftValid && !rightValid) {
    return 0;
  }

  if (!leftValid) {
    return 1;
  }

  if (!rightValid) {
    return -1;
  }

  return leftMd - rightMd;
}

export function sortTrajectoryPointsByMd(points: FactTrajectoryPointEntity[]): FactTrajectoryPointEntity[] {
  if (points.length < 2) {
    return points;
  }

  return [...points].sort(compareTrajectoryPointsByMd);
}
